// Mixins
import { capitalizeFirstLetter } from "@/utils/text-utils.js";
import { dateMixins } from "@/app/mixins/utils/date-mixins";
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";

// Components
const ModalMatingDogChange = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "modal-mating-dog-change" */ "@/app/views/main-view/breeders/components/modal-mating-dog-change/modal-mating-dog-change.vue"
    );

export default {
    name: "MatingDamSireDetailsContainer",
    components: {
        ModalMatingDogChange,
    },
    directive: {},
    filters: {},
    mixins: [dateMixins, toastMessageMixins],
    props: {
        matingName: String,
        damDetails: Object,
        sireDetails: Object,
    },
    data() {
        return {
            damMatingInfo: {
                whelpDate: "N/A",
                typeOfBirth: "N/A",
            },
            matingId: null,

            updatedMatingName: "",
            selectedSire: null,
            initialSire: null,
            isAPISubmitLoading: false,
        };
    },
    watch: {
        damDetails: {
            handler(newVal) {
                if (newVal) {
                    this.damWhelpingInfo();
                }
            },
            deep: true,
            immediate: true,
        },
        sireDetails: {
            handler(newVal) {
                if (newVal) {
                    this.selectedSire = this.sireDetails;

                    if (this.sireDetails) {
                        const { breedName, dogName } = this.sireDetails;

                        this.selectedSire = {
                            ...this.sireDetails,
                            customLabel: `${breedName} - ${dogName}`,
                        };

                        this.initialSire = this.selectedSire;
                    }
                }
            },
            deep: true,
            immediate: true,
        },
    },
    created() {
        this.matingId = this.$route.query.id;
        this.damWhelpingInfo();
    },
    methods: {
        onChangeSire(sireDetails) {
            this.selectedSire = sireDetails;

            if(sireDetails){
                this.updatedMatingName = `${this.damDetails.dogName} x ${this.selectedSire.dogName}`;
            } else{
                this.updatedMatingName = this.damDetails.dogName;
            }
        },
        onShowModalChangeSire() {
            this.$refs.modalMatingDogChange.show(this.selectedSire);
        },
        hasImageUrl(source) {
            if (!source || !source.imageUrl) {
                return require("@/assets/images/_shared/dog-purchase.png");
            }

            return source.imageUrl;
        },
        hasValidDogName(details) {
            if (!details || !details.dogName) {
                return "Dog Name";
            }
            return this.formatText(details.dogName);
        },
        hasValidDogBreed(details) {
            if (!details || !details.breedName) {
                return "Unknown Breed";
            }
            return details.breedName;
        },

        hasValidBirthDate(details) {
            if (!details || !details.birthdate) {
                return "Not Specified";
            }
            return this.formatDateWithoutConversion(details.birthdate);
        },
        formatText(text) {
            return capitalizeFirstLetter(text);
        },
        damWhelpingInfo() {
            let whelpDate = "N/A";
            let typeOfBirth = "N/A";
            if (this.damDetails && this.damDetails.whelpingDates) {
                const whelpingInfo = this.damDetails.whelpingDates.find((whelping) => whelping.matingId == this.matingId);

                if (whelpingInfo) {
                    if (whelpingInfo.typeOfBirth) {
                        typeOfBirth = whelpingInfo.typeOfBirth;
                    }
                    if (whelpingInfo.whelpingDate) {
                        whelpDate = this.formatDateWithoutConversion(whelpingInfo.whelpingDate);
                    }
                }
            }

            this.damMatingInfo = { whelpDate, typeOfBirth };
        },
    },
};
